import styled from "styled-components";
import Search from "../Search";
import SegmentedToggle from "../SegmentedToggle";
import { zIndex } from "../../constants";

export const Global = styled.div`
  --color-primary: #002B43;
  --color-secondary: #002B43;
  --color-tertiary: #4EB1E9;
  --color-accent: #f4772d;
  --color-light: #f0f7fc;
  --color-gray: #808080;
  --color-med-gray: #B9B9B9;
  --color-light-gray: #EAEAEA;
  --color-text-gray: #54595F;
  --font-primary: "reader medium";
  --font-mono: "apercu mono";
  font-size: 14px;
  height: 100%;
`;

export const MapContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 100%;
  height: 100%;
  overflow-y: hidden;
  /* width: 940px; */
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 0;
  overflow-y: hidden;
`;

export const Container = styled.div`
  position: relative;
  overflow-x: hidden;
  width: 100%;
  height: calc(100% - 51px);
  overflow-y: hidden;
  /* height: 485px; */
`;

export const MapSearch = styled(Search)`
  width: 100%;
  height: 52px;
`;

export const MapViewHeader = styled.div`
  background: var(--color-primary);
  display: flex;
  justify-content: center;
`;

export const MapViewToggle = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: 15px;
  z-index: ${zIndex.legendToggle};
  top: 70px;
  width: 100%;

  @media (min-width: 640px){
    display: none;
  }
`;

export const MapViewButtons = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px;
`;

export const DesktopSchoolStateToggle = styled(SegmentedToggle)`
  display: none;
  margin: 20px auto 20px auto;

  @media (min-width: 640px) {
    display: inline-flex;
  }
`;
